<template>
  <v-container  v-if="cargando" >
    <v-btn color="orange" @click="volver" left dark> Volver </v-btn>
    <v-form ref="form" lazy-validation>
      <h4 style="padding-top: 40px">
        Modificación usuario: {{ this.$route.params.correo }}
      </h4>
      <v-text-field
        style="padding-top: 40px"
        v-model="nombre"
        label="Nombre"
        :rules="reglaTexto"
        append-icon="mdi-clipboard-account"
      >
      </v-text-field>
      <v-text-field
        v-model="contrasena"
        :type="verContrasena ? 'text' : 'password'"
        label="Contraseña (Si no desea cambiarlo, dejelo en blanco)"
        :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
        required
        :rules="reglaContrasena"
        @click:append="verContrasena = !verContrasena"
      >
      </v-text-field>
      <v-switch v-model="administrador"  label="Administrador"></v-switch>
      <v-select
        v-if="!administrador"
        style="padding-bottom: 20px"
        v-model="grupoAcceso"
        :items="arrayNombreGruposAccesos"
        menu-props="auto"
        label="Selecciona un Grupo"
        hide-details
        prepend-icon="mdi-group"
        single-line
      ></v-select>
      <v-switch v-model="compartir" v-if="!administrador" label="Compartir Archivos"></v-switch>
      <v-switch v-model="bloqueado"  label="Bloqueado"></v-switch>
      <v-btn color="green" @click="guardarUsuarioEditado" absolute center dark>
        Guardar Usuario
        <v-icon right dark> mdi-content-save-all </v-icon>
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data() {
    return {
      nombre: "",
      administrador: false,
      bloqueado: "",
      reglaTexto: [(v) => !!v || "Campo Requerido"],
      usuarioCargado: false,
      contrasena: "",
      verContrasena: false,
      compartir:"",
      grupoAcceso: "",
      arrayNombreGruposAccesos: [],
      arrayGrupoAccesos:[],
      reglaContrasena: [
        (v) => !!v || "Correo Requerido",
        (v) => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
        (v) => (v || "").length > 7|| "Se necesitan 8 caracteres minimo",
      ],
      cargando: false,
      idGrupoAcceso:""
    };
  },
  methods: {
    //Obtenemos usuario
    obtenerUsuario() {
      ApiZD.obtenerUsuario(this.$route.params.correo)
        .then((resultado) => {
          this.nombre = resultado.data.usuario.nombre;
          this.administrador = resultado.data.usuario.administrador;
          this.bloqueado = resultado.data.usuario.bloqueado;
          this.grupoAcceso = resultado.data.usuario.id_grupo;
          if(resultado.data.usuario.compartir) this.compartir = resultado.data.usuario.compartir;
          this.obtenerGruposAccesos();
        });

    },
    obtenerGruposAccesos() {
      ApiZD.obtenerGrupoAccesos()
        .then((resultado) => {
          resultado.data.grupos.forEach((grupo) => {
            this.arrayNombreGruposAccesos.push(grupo["nombre"]);
          });
        this.arrayGrupoAccesos = resultado.data.grupos;
        this.obtenerNombreDeGrupoDeAccesoConId(this.grupoAcceso)
        })
        .catch((e) => {
          this.$router.push({ path: "/principal" });
        })

    },
    //Volvemos una pagina anterior
    volver() {
      this.$router.go(-1);
    },

    obtenerIdDelNombreDelGrupo(nombreGrupo) {
      this.arrayGrupoAccesos.forEach((grupo) =>{
        if(grupo['nombre'] == nombreGrupo)
          this.idGrupoAcceso = grupo['id'];
      })
    },
    //Guardamos los datos de la edicion
    guardarUsuarioEditado() {
      if (
        this.nombre == "" ||
        this.grupoAcceso == "" && this.administrador == false
      ) {
        this.$root.$dialogo.activarDialogo(
          "Fallo datos",
          "Rellena correctamente todos los datos para poder registrarte",
          ["OK"]
        );
      } else {
      this.obtenerIdDelNombreDelGrupo(this.grupoAcceso)
      if (this.administrador){
        this.grupoAcceso = null;
        this.compartir = true;
      }
      ApiZD.editarUsuario(
        this.$route.params.correo,
        this.nombre,
        this.contrasena,
        this.administrador,
        this.bloqueado,
        this.idGrupoAcceso,
        this.compartir
      ).then(() => {
        this.$router.push({ path: "/principalUsuarios" });
      });
      }
    },
    obtenerNombreDeGrupoDeAccesoConId (id) {
      this.arrayGrupoAccesos.forEach((grupo) =>{
        if(grupo['id'] == id)
          this.grupoAcceso = grupo['nombre'];
      })
      this.cargando = true;

    }
  },
  created() {
    this.obtenerUsuario();
  },
};
</script>

<style scoped>

</style>